import styled from 'styled-components';
const MyDiv = styled.div`
  .page_wrapper {
    overflow-x: hidden;
    max-width: 100%;
    padding: 20px;
    border-radius: 8px;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  }
  .flex_header {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;    
  }
    .selected {
  border: 1px solid #006838; 
}
  .filter_section {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .icon_btn {
    min-width: 40px;
    cursor: pointer;
  }
 .table_wrapper {
  background: #fff;
  border: 1px solid #EAECF0;
  border-radius: 7px;
  box-shadow: 0 1px 4px rgba(234, 236, 240, 1);
}

  th, td {
    text-align: left;
    padding: 12px;
    font-size: 14px;
    width: max-content;        /* Auto size to fit content */
  min-width: fit-content;
  }
  th {
    font-weight: 600;
    color: rgba(0, 0, 0, 1);

  } 
  .bonus{
   border-radius: 44px;
  }
  .status_badge {
    padding: 3px 6px;
    font-size: 12px;
    border-radius: 4px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    display: inline-block;
  }
  .status_badge.green { background-color: #dcfce7; color: #15803d; }
  .status_badge.red { background-color: #fee2e2; color: #b91c1c; }
  .status_badge.orange { background-color: #fff7ed; color: #c2410c; }
  .status_badge.blue { background-color: #e0f2fe; color: #0369a1; }
  .status_badge.purple { background-color: #ede9fe; color: #6d28d9; }

`;

export default MyDiv;

